<template>
  <div>
    <Breadcrumb :items="breadcrumbItems" />
    
    <IpgForm
      @save="handleSave"
      @cancel="handleCancel"
    />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import IpgForm from "../../../components/forms/IpgForm.vue";
import { IpgService } from "../../../services/IpgService";

export default {
  name: "CriarIpg",
  components: {
    Breadcrumb,
    IpgForm
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "Página Inicial",
          disabled: false,
          href: "/"
        },
        {
          text: "Gerenciamento de IPGs",
          disabled: false,
          href: "/gerenciar-ipgs"
        },
        {
          text: "Cadastrar IPG",
          disabled: true,
          href: "/ipgs/criar"
        }
      ]
    };
  },
  methods: {
    async handleSave(formData) {
      const postData = new FormData();
      
      postData.append("exercicio", formData.exercicio);
      postData.append("codigo_ipg", formData.codigo_ipg);
      postData.append("descricao", formData.descricao);
      postData.append("ativo", formData.ativo ? 1 : 0);
      
      const response = await IpgService.store(postData);
      
      if (response) {
        this.$router.push('/gerenciar-ipgs');
      }
    },
    handleCancel() {
      this.$router.push('/gerenciar-ipgs');
    }
  }
};
</script>

<style scoped>
/* Estilos específicos da página, se necessário */
</style>